<script setup lang="ts">
import { RouterView, useRouter } from "vue-router";

import GlobalSnackbar from "@/components/GlobalSnackbar.vue";
import NavigationBar from "@/components/NavigationBar.vue";

import useLoginManager from "@/services/loginManager";
import "@/styles/global.scss";
import { storeToRefs } from "pinia";
import { computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useSettingsStore } from "./stores/settings";

const router = useRouter();
const route = useRoute();
const { theme, language } = storeToRefs(useSettingsStore());
const i18n = useI18n({});
const loginManager = useLoginManager();

const viewName = computed(() => {
  if (loginManager.userInfo.value?.dealer && route.matched[0].components?.dealer) {
    return "dealer";
  } else {
    return "default";
  }
});

function setLocale() {
  i18n.locale.value = language.value;
}

watch(language, () => {
  setLocale();
});
setLocale();
</script>

<template>
  <template v-if="router.currentRoute.value.meta.fullscreen">
    <v-app>
      <v-main>
        <v-container
          fluid
          class="fill-height"
        >
          <router-view
            v-slot="{ Component }"
            name="fullscreen"
          >
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </v-container>
      </v-main>
    </v-app>
  </template>

  <template v-if="!router.currentRoute.value.meta.fullscreen && router.currentRoute.value.matched.length > 0">
    <v-app :theme="theme">
      <div
        class="tw:overflow-visible"
        style="height: 56px"
      >
        <navigation-bar />
      </div>

      <v-main class="tw:!pb-0">
        <v-container class="tw:!mx-0 tw:!max-w-full tw:h-full tw:!p-4">
          <router-view
            v-slot="{ Component }"
            :key="route.fullPath"
            :name="viewName"
          >
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </v-container>
      </v-main>
    </v-app>
  </template>

  <GlobalSnackbar />
</template>

<style lang="scss" scoped>
.text-small {
  font-size: 70%;
}
</style>

<style lang="scss">
.v-application .v-application__wrap {
  max-width: 120rem;
  margin: 0 auto;
}
</style>
